import { render, staticRenderFns } from "./ExaminerPerRoom.vue?vue&type=template&id=545a379e&scoped=true"
import script from "./ExaminerPerRoom.vue?vue&type=script&lang=js"
export * from "./ExaminerPerRoom.vue?vue&type=script&lang=js"
import style0 from "./ExaminerPerRoom.vue?vue&type=style&index=0&id=545a379e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a379e",
  null
  
)

export default component.exports